import { Button, Box, Table, TableContainer } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Scrollbar from 'src/components/scrollbar/Scrollbar';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DynamicHeightComponent from 'src/utils/dynamicSize.component';
import ScheduledReportGridBody from './PostGridBody.component';
import ScheduledReportGridHead from './PostGridHead.component';
import ScheduledReportPagination from './PostGridPagination.component';
import CreateScheduledReportComponent from '../create-scheduled-report';
import { useRightSidebar } from 'src/layouts/right-side-bar/rightSidebarProvider';

const ScheduledReportGrid = ({ scheduledList, handleReCallScheduleReport }) => {
  const { t: translate } = useTranslation();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { showRightSidebar } = useRightSidebar();
  const [height, setHeight] = useState(window.innerHeight - 150);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleCreateScheduledReport = () => {
    let data = {
      content: sideBarView,
    };
    showRightSidebar(data);
  };

  const sideBarView = () => {
    return <CreateScheduledReportComponent handleReCallScheduleReport={handleReCallScheduleReport} />;
  };

  const handleRequestSort = (event, property) => {};

  return (
    <>
      {scheduledList && scheduledList.length > 0 ? (
        <DynamicHeightComponent>
          <Scrollbar>
            <TableContainer
              sx={{
                maxHeight: 'calc(94vh - 111px)',
                minHeight: 'calc(94vh - 111px)',
                height: height - 60,
              }}
            >
              <Table stickyHeader size="small">
                <ScheduledReportGridHead scheduledList={scheduledList} handleRequestSort={handleRequestSort} />
                <ScheduledReportGridBody
                  scheduledList={scheduledList}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  handleReCallScheduleReport={handleReCallScheduleReport}
                />
              </Table>
            </TableContainer>
            <ScheduledReportPagination
              scheduledList={scheduledList}
              page={page}
              rowsPerPage={rowsPerPage}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </Scrollbar>
        </DynamicHeightComponent>
      ) : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 'calc(100vh - 150px)', // Adjust for header height
            bgcolor: 'background.default',
          }}
        >
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<AddCircleIcon />}
            onClick={handleCreateScheduledReport}
            sx={{
              padding: '12px 24px',
              fontSize: '1.1rem',
              boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
              '&:hover': {
                transform: 'scale(1.05)',
                boxShadow: '0 6px 12px rgba(0,0,0,0.3)',
                bgcolor: 'primary.dark',
              },
            }}
          >
            {translate('report.create_scheduled_report')}
          </Button>
        </Box>
      )}
    </>
  );
};

export default ScheduledReportGrid;
